export const contentEs = {
  lang: 'es',
  meta: {
    home: {
      title: 'Doña Blanca — Comedores Industriales y Soluciones de Alimentación para Empresas',
      description: 'Operación de comedores industriales, corporativos y alimentación para empresas a gran escala en CDMX y zona metropolitana, respaldados por la tradición y sabor de nuestras 13 sucursales.',
    },
    business: {
      title: 'Comedores para Empresas y Alimentación Corporativa | Doña Blanca',
      description: 'Servicios de alimentación diseñados alrededor de tu operación: comedores industriales, comedores ejecutivos, eventos corporativos y distribución diaria con los más altos estándares de inocuidad y sabor.',
    },
    locations: {
      title: 'Nuestras Sucursales en CDMX — Sabor Tradicional | Doña Blanca',
      description: 'Conoce nuestras 13 sucursales en la Ciudad de México: cocina cotidiana mexicana, desayunos, comidas completas y pan recién horneado. El sabor tradicional que respalda nuestra operación.',
    },
    invoice: {
      title: 'Contacto y Facturación de Consumo | Doña Blanca',
      description: 'Solicita tu factura CFDI de consumo en sucursales o ponte en contacto con nuestro equipo comercial para cotizaciones de comedores y servicios de alimentación para empresas.',
    },
    title: 'Doña Blanca — Comedores Industriales y Soluciones de Alimentación para Empresas',
    description: 'Operación de comedores industriales, corporativos y alimentación para empresas a gran escala en CDMX y zona metropolitana, respaldados por la tradición y sabor de nuestras 13 sucursales.',
  },
  nav: {
    brand: 'Doña Blanca',
    business: 'Soluciones para empresas',
    operation: 'Nuestra operación',
    locations: 'Nuestras sucursales',
    invoice: 'Contacto y facturación',
    cta: 'Hablemos de tu operación',
    switchLang: 'EN',
    switchLangUrl: '/en',
  },
  home: {
    hero: {
      headline: 'Sabor todos los días.',
      headlineAccent: 'Operación a gran escala.',
      body: 'De nuestras sucursales propias a soluciones de alimentación para empresas, combinamos cocina mexicana, experiencia operativa y procesos diseñados para servir con consistencia todos los días.',
      ctaBusiness: 'Háblanos de tu operación',
      ctaLocations: 'Conoce nuestras sucursales',
    },
    stats: {
      sinceLabel: 'Desde',
      locationsLabel: 'Sucursales',
      pointsLabel: 'Puntos de operación',
      platesLabel: 'de platos servidos',
      tagline: 'Servimos todos los días.',
      subtagline: 'En nuestras sucursales y en las operaciones de nuestros clientes.',
    },
    paths: {
      b2b: {
        eyebrow: 'PARA EMPRESAS',
        title: 'Alimentación diseñada alrededor de tu operación.',
        text: 'Soluciones de alimentación para empresas, desde un solo centro de trabajo hasta operaciones con múltiples ubicaciones, producción, distribución y seguimiento.',
        cta: 'Conoce nuestras soluciones →',
        href: '/empresas',
      },
      b2c: {
        eyebrow: 'NUESTRAS SUCURSALES',
        title: 'Doña Blanca todos los días.',
        text: 'Desayunos, comidas, pan recién horneado y la experiencia cotidiana con la que nació nuestra marca.',
        cta: 'Conoce nuestras sucursales →',
        href: '/sucursales',
      },
    },
  },
  business: {
    hero: {
      eyebrow: 'SOLUCIONES PARA EMPRESAS',
      title: 'Alimentación diseñada alrededor',
      titleAccent: 'de tu operación.',
      body: 'Sabemos que cada organización es diferente. Por eso diseñamos soluciones de alimentación que se adaptan al número de personas, ubicaciones, horarios, infraestructura y necesidades de tu operación, con la calidad, consistencia y experiencia que nos caracteriza.',
      cta: 'Háblanos de tu operación →',
    },
    solutions: [
      {
        num: '01',
        title: 'Comedores industriales',
        desc: 'Operación diaria de alimentación para plantas, centros de trabajo y organizaciones que necesitan atender a sus colaboradores de forma consistente. Desde la planeación del servicio hasta la preparación y entrega de alimentos.',
      },
      {
        num: '02',
        title: 'Comedores corporativos',
        desc: 'Soluciones para oficinas y espacios corporativos que buscan ofrecer una experiencia de alimentación confiable y agradable para sus equipos.',
      },
      {
        num: '03',
        title: 'Operaciones multisede',
        desc: 'Coordinación de alimentación para organizaciones que necesitan atender diferentes ubicaciones bajo una misma operación.',
      },
      {
        num: '04',
        title: 'Producción y distribución',
        desc: 'Preparación centralizada y coordinación logística para abastecer distintos puntos de servicio de manera organizada.',
      },
      {
        num: '05',
        title: 'Soluciones a la medida',
        desc: 'Cada organización funciona de manera diferente. Diseñamos el modelo de servicio alrededor de las necesidades reales de cada operación.',
      },
    ],
    operation: {
      id: 'operacion',
      title: 'Mucho sucede antes de servir',
      titleAccent: 'un plato.',
      body: 'Una operación de alimentación confiable requiere mucho más que una cocina. Abastecimiento, producción, preparación, surtido, distribución y recepción forman parte de una misma cadena. En Doña Blanca hemos desarrollado capacidades propias para coordinar cada una de estas etapas y mantener mayor consistencia conforme una operación crece.',
      steps: [
        { num: '01', name: 'Abastecimiento', desc: 'Seleccionamos los mejores insumos con proveedores de confianza.' },
        { num: '02', name: 'Producción', desc: 'Procesamos y preparamos insumos en plantas propias con altos estándares de calidad.' },
        { num: '03', name: 'Cocina', desc: 'Integramos recetas auténticas con consistencia y sabores que nos distinguen.' },
        { num: '04', name: 'Panadería', desc: 'Elaboramos nuestro pan y postres frescos todos los días en nuestra propia panadería.' },
        { num: '05', name: 'Distribución', desc: 'Llevamos nuestros productos a todas las sucursales y operaciones con logística propia.' },
        { num: '06', name: 'Recepción', desc: 'Validamos cada entrega para asegurar la calidad y trazabilidad en destino.' },
      ],
    },
    production: {
      title: 'Mayor control empieza desde la preparación.',
      body: 'Contar con capacidades propias de producción nos permite tener mayor visibilidad sobre una parte fundamental de la cadena de alimentación. Nuestra operación integra distintas áreas de preparación que trabajan de manera coordinada para abastecer las necesidades diarias de servicio.',
      highlights: [
        { title: 'COCINA CENTRAL', desc: 'Estandarización de bases, salsas y preparaciones maestras con trazabilidad estricta.' },
        { title: 'PANADERÍA PROPIA', desc: 'Horneo diario propio de bolillo, pan dulce y repostería artesanal.' },
        { title: 'PREPARACIÓN ESPECIALIZADA', desc: 'Áreas dedicadas para carnes, frutas, verduras y lácteos con inocuidad.' },
        { title: 'ABASTECIMIENTO COORDINADO', desc: 'Flujo continuo desde el CEDIS hacia cada comedor y punto de servicio.' },
      ],
      closing: 'Esto nos permite avanzar hacia una operación más consistente, organizada y preparada para crecer.',
    },
    bakery: {
      eyebrow: 'PANADERÍA PROPIA',
      title: 'Hay cosas que preferimos',
      titleAccent: 'seguir haciendo nosotros.',
      body: 'Producimos nuestro propio pan y postres frescos como parte de nuestra operación cotidiana. Tener producción propia nos permite mantener mayor control sobre producto, frescura, consistencia y abastecimiento.',
    },
    tech: {
      title: 'Una operación conectada',
      titleAccent: 'de principio a fin.',
      body: 'A medida que una operación crece, saber qué está sucediendo en cada etapa se vuelve tan importante como cocinar bien. Por eso incorporamos herramientas digitales para mejorar el seguimiento de nuestros procesos y tener mayor visibilidad sobre el recorrido de cada solicitud.',
      flow: [
        { name: 'Solicitud', note: 'Planeación de necesidades' },
        { name: 'Producción', note: 'Procesamiento de insumos' },
        { name: 'Preparación', note: 'Cocina y panadería' },
        { name: 'Transporte', note: 'Distribución programada' },
        { name: 'Recepción', note: 'Entrega y validación' },
      ],
      points: [
        'Más trazabilidad.',
        'Más control.',
        'Mejor capacidad de respuesta.',
      ],
      clarification: 'La tecnología no sustituye la experiencia de nuestra operación. La ayuda a ser más visible, coordinada y escalable.',
    },
    flexibility: {
      title: 'Cada operación es diferente.',
      factors: ['Volúmenes', 'Horarios', 'Distancias', 'Múltiples ubicaciones', 'Cambios', 'Personas'],
      body: 'Por eso nuestra propuesta no parte de un modelo único. Parte de entender cómo funciona cada organización y construir alrededor de ella una operación de alimentación que pueda mantenerse todos los días.',
      cta: 'Cuéntanos cómo funciona tu operación →',
    },
    differentiator: {
      title: 'Sabemos cocinar.',
      titleAccent: 'Sabemos operar.',
      body: 'Nuestra diferencia está en reunir capacidades que normalmente viven por separado.',
      pillars: [
        { title: 'Operación diaria real', desc: 'Vivimos el día a día del servicio con nuestros propios equipos en piso.' },
        { title: 'Producción propia', desc: 'Cocina central que garantiza sabor, calidad y consistencia en cada punto.' },
        { title: 'Panadería propia', desc: 'Pan recién hecho todos los días, parte esencial de nuestra identidad.' },
        { title: 'Capacidad multisede', desc: 'Operación estandarizada que mantiene la misma experiencia en todas tus ubicaciones.' },
        { title: 'Tecnología y trazabilidad', desc: 'Procesos y herramientas que aseguran calidad, seguridad y eficiencia.' },
        { title: 'Cercanía con el consumidor', desc: 'Escuchamos, aprendemos y mejoramos todos los días con base en la experiencia de comensales.' },
      ],
    },
    contact: {
      id: 'contacto',
      eyebrow: 'CONTACTO COMERCIAL',
      title: 'Hablemos de tu operación.',
      body: 'Cada organización tiene una realidad distinta. Cuéntanos cuántas personas necesitas atender, dónde se encuentran y cómo funciona actualmente tu operación. Nuestro equipo puede ayudarte a diseñar una solución.',
      points: [
        { title: 'Atención personalizada', desc: 'Un asesor especializado te acompañará en todo el proceso.' },
        { title: 'Soluciones a la medida', desc: 'Diseñamos una propuesta de acuerdo con tus necesidades.' },
        { title: 'Cobertura en CDMX y área metropolitana', desc: 'Operamos en múltiples puntos con logística propia consolidada.' },
      ],
      form: {
        empresa: 'Empresa',
        empresaPlaceholder: 'Nombre de tu empresa',
        nombre: 'Nombre',
        nombrePlaceholder: 'Tu nombre completo',
        correo: 'Correo',
        correoPlaceholder: 'tu@empresa.com',
        telefono: 'Teléfono',
        telefonoPlaceholder: '55 1234 5678',
        ciudad: 'Ciudad',
        personas: 'Número aproximado de personas',
        personasPlaceholder: 'Ej. 250',
        ubicaciones: 'Número de ubicaciones',
        ubicacionesPlaceholder: 'Ej. 3',
        tipoServicio: 'Tipo de servicio',
        tipoServicioOptions: [
          'Comedor industrial',
          'Comedor corporativo',
          'Operación multisede',
          'Producción y distribución',
          'Otro',
        ],
        mensaje: 'Cuéntanos brevemente qué necesitas',
        mensajePlaceholder: 'Platícanos sobre tu operación, horarios, ubicaciones u otra información relevante.',
        submitBtn: 'Quiero hablar con Doña Blanca',
        whatsappBtn: 'Prefiero WhatsApp',
        disclaimer: 'Formulario de demostración — envío comercial pendiente de conexión de endpoint oficial.',
        demoSuccess: 'Mensaje registrado localmente para fines de demostración. Nuestro equipo te contactará.',
      },
    },
  },
  b2c: {
    hero: {
      eyebrow: 'NUESTRAS SUCURSALES',
      title: 'Antes de hablar de escala,',
      titleAccent: 'aprendimos a servir persona por persona.',
      body: 'Nuestras sucursales son el origen de Doña Blanca. Aquí servimos desayunos, comidas y pan recién hecho, con el mismo sabor y consistencia que nos ha acompañado desde el primer día.',
      cta: 'Encuentra tu Doña Blanca →',
    },
    flavor: {
      eyebrow: 'NUESTRO SABOR',
      title: 'La escala importa.',
      titleAccent: 'El sabor también.',
      body: 'En nuestras sucursales servimos platillos hechos con ingredientes de calidad, recetas de cocina mexicana cotidiana y pan recién horneado para todos los momentos del día.',
      cards: [
        {
          title: 'Desayuno',
          desc: 'Clásicos de la mañana, hechos al momento para empezar bien el día: chilaquiles, huevos al gusto, café de olla y fruta fresca.',
          tag: 'Mañanas de 8 a 13 hrs',
        },
        {
          title: 'Comida mexicana',
          desc: 'Platillos tradicionales con el sabor de siempre. Menú en tres tiempos que cambia diariamente con guisados caseros.',
          tag: 'Comidas de 13 a 17 hrs',
        },
        {
          title: 'Pan y postres',
          desc: 'Pan recién hecho todos los días por nuestros propios maestros panaderos para acompañar cualquier ocasión.',
          tag: 'Horneo diario',
        },
      ],
    },
    bakery: {
      eyebrow: 'PANADERÍA PROPIA',
      title: 'Pan recién hecho todos los días.',
      body: 'Nuestro pan y postres forman parte de la experiencia diaria de Doña Blanca y se elaboran dentro de nuestra propia operación.',
    },
    history: {
      eyebrow: 'NUESTRA HISTORIA',
      title: 'Cocinar bien. Servir bien. Hacerlo todos los días.',
      body: 'Doña Blanca surge en 2010 alrededor de una idea sencilla: crear un espacio cálido y agradable para disfrutar la comida diaria. Desde entonces, desayunos, comidas y panadería han formado parte de nuestra historia. Con el tiempo crecieron las sucursales, los equipos y nuestra capacidad operativa. Pero seguimos partiendo del mismo lugar: cocinar bien, servir bien y hacerlo todos los días.',
    },
    directory: {
      id: 'directorio',
      eyebrow: 'DIRECTORIO DE SUCURSALES',
      title: 'Encuentra tu Doña Blanca más cercana',
      searchPlaceholder: 'Busca por sucursal o colonia (ej. Cuauhtémoc, Nápoles, Roma)...',
      allBadge: 'Todas las sucursales (14)',
      howToGet: 'Cómo llegar',
      breakfastHours: 'Desayunos:',
      lunchHours: 'Comidas:',
      viewMenu: 'Ver menú',
      orderDelivery: 'Pedir en Rappi',
      noResults: 'No se encontraron sucursales para el término de búsqueda.',
      missingDataNotice: 'Horarios y detalles en actualización',
    },
  },
  invoice: {
    eyebrow: 'ATENCIÓN AL CLIENTE',
    title: 'Estamos para ayudarte',
    subtitle: 'Ya sea que quieras conocer nuestras soluciones de alimentación, resolver alguna duda o solicitar una factura, estamos aquí para ayudarte.',
    contact: {
      title: 'Hablemos',
      text: '¿Tienes alguna pregunta, comentario o quieres conocer más sobre Doña Blanca? Escríbenos y nuestro equipo dará seguimiento a tu mensaje.',
      successMsg: '¡Gracias por escribirnos! Hemos recibido tu mensaje y nuestro equipo dará seguimiento.',
      btn: 'Enviar mensaje',
      sendingBtn: 'Enviando mensaje...',
      reasons: [
        'Información general',
        'Comedores para empresas',
        'Nuestras sucursales',
        'Comentarios o sugerencias',
        'Otro',
      ],
    },
    billing: {
      title: 'Solicita tu factura',
      text: 'Compártenos tus datos fiscales y la información de tu consumo. Nuestro equipo administrativo revisará tu solicitud y te enviará la factura al correo que nos proporciones.',
      notice: 'La factura no se genera automáticamente. Nuestro equipo revisará tu solicitud y realizará el proceso correspondiente.',
      successMsg: '¡Solicitud recibida! Nuestro equipo administrativo revisará la información y dará seguimiento a tu factura.',
      btn: 'Enviar solicitud de factura',
      sendingBtn: 'Enviando solicitud...',
      regimes: [
        '601 - General de Ley Personas Morales',
        '603 - Personas Morales con Fines no Lucrativos',
        '605 - Sueldos y Salarios e Ingresos Asimilados a Salarios',
        '606 - Arrendamiento',
        '612 - Personas Físicas con Actividades Empresariales y Profesionales',
        '621 - Incorporación Fiscal',
        '626 - Régimen Simplificado de Confianza (RESICO)',
        'Otro régimen fiscal',
      ],
      cfdiUses: [
        'G03 - Gastos en general',
        'G01 - Adquisición de mercancías',
        'S01 - Sin efectos fiscales',
        'CP01 - Pagos',
        'Otro uso de CFDI',
      ],
    },
  },
  footer: {
    tagline: 'Sabor todos los días. Operación a gran escala.',
    links: {
      business: 'Soluciones para empresas',
      operation: 'Nuestra operación',
      locations: 'Nuestras sucursales',
      invoice: 'Contacto',
      contact: 'Hablemos de tu operación',
      privacy: 'Aviso de privacidad',
      terms: 'Términos y condiciones',
    },
    city: 'Ciudad de México, México',
    quickLinksTitle: 'Accesos rápidos',
    findBranch: 'Encuentra tu Doña Blanca',
    findBranchDesc: 'Conoce nuestras 14 sucursales en CDMX',
    seeMenu: 'Ver menú del día',
    seeMenuDesc: 'Descubre nuestros platillos de diario',
    invoiceShort: 'Facturar mi consumo',
    invoiceShortDesc: 'Genera tu factura de forma rápida',
    copyright: '© 2026 Doña Blanca. Todos los derechos reservados. "Doña Blanca" es una marca registrada de A+A Servicios.',
  },
};
